import api from './api'
import { defActionSlice } from '../../../../helpers/defaultAction'
import { tariffRateReducer } from './reducer'

const {
    setLoading,
    setError,
    getListSuccess,
    clear
} = tariffRateReducer.actions

export const getTariffRates = (values) => {
	const defObj = {
		req: setLoading,
		suc: getListSuccess,
		fail: setError,
		service: {
			params: values,
			func: api.getListByYear
		}
	}
	return defActionSlice(defObj)
}

export const clearAction = (values) => {
	const defObj = {
		req: clear,
	}
	return defActionSlice(defObj)
}
